import _ from 'lodash';
import React from 'react';
import Promise from 'bluebird';


import Api from '../../api';
import component, {classnames, navigateTo, makePath} from '../component';
import TopBanner from '../TopBanner';
import TopHeader from '../TopHeader';
import SubNav from '../SubNav';
import Link from '../Link';
import SearchBar from '../SearchBar';
import DataEditButton from '../DataEditButton';
import LoadMoreButton from '../LoadMoreButton';
import {Table, Tr, Th, Td} from '../Table';
import {HBox, VBox} from '../Box';
import Flag from '../Flag';
import {TableListRow, TableListCell} from '../TableList';
import teamRoles from '../teamRoles';
import {Caution} from './../icons';

import {teamCheckActiveTournament} from './../teamCheckActiveTournament';

import notices from './../notices';

export default component('Players', function({data, params, query}) {

  const subNav = data.getIn(['nav'])
      .find(x => x.get('name') === 'players')
      .get('children');

  const submit = () => {
    navigateTo(makePath('players', params, query));
  };

  async function loadMore() {
    data.setIn(['users', 'loading'], true);
    await Api.users(data, params, query);
    data.setIn(['users', 'loading'], false);
  }

  const qPath = ['route', 'query', 'query'];
  if (!data.getIn(qPath)) {
    data.setIn(qPath, '');
  }

  const sb = <SearchBar data={data.cursor(qPath)}
                        placeholder='Найти игрока' onSubmit={submit} />;


  const btnMore = data.getIn(['users', 'noMore'])
      ? null
      : <LoadMoreButton text='игроков' onClick={loadMore}
                        loading={data.getIn(['users', 'loading'])} />;

  const showNotice = (message) => {
    data.cursor('popup').set({
      icon: Caution,
      message: message,
      action: 'Ok',
      iconWidth: 128,
      iconHeight: 128,
      autoClose: true
    });
  };


  const invitePlayer = async function(user) {
    if( !data.get('user') ){
      showNotice(notices.authBeforeInvitingPlayer);
      return false;
    }
    if( !data.getIn(['user', 'has_team']) ){
      showNotice(notices.createTeamBeforeInvite);
      return false;
    }
    if( data.getIn(['user', 'member_role']) !== teamRoles.captain.id ){
      showNotice(notices.onlyCaptainCanInvite);
      return false;
    }
    if( data.getIn(['team', 'member_count']) === 7 ){
      showNotice(notices.teamFullCanNotInvite);
      return false;
    }

    if( teamCheckActiveTournament(data.get('team'), data.cursor('popup')) ){
      user.setIn('invite_sent', true);
      await Api.userInvite({id: user.get('id')});
    }
  };

  const invitePlayerCancel = async function(user) {
    user.setIn('invite_sent', false);
    await Api.userInviteCancel({id: user.get('id')});
  };



  return (
    <div>
      <TopBanner size='small' align={false}>
        <TopHeader left>Игроки</TopHeader>
        <SubNav data={subNav} params={params} query={query} defaultQuery={{sort: '-score'}}
                label='Сортировать по' SearchBar={sb} />
      </TopBanner>
      <VBox width={4} isContainer className='PlayerList'>
        {
          data.cursor(['users', 'list']).hasData() ?
            <div>
              {
                data.cursor(['users', 'list']).map((user) => {

                  const itemImage = user.get('image');
                  const bgImage = itemImage
                      ? itemImage + '?crop=1&w=104&h=104'
                      : require('../../img/teamEmptyAvatarSquare.png');

                  return <TableListRow key={user.get('id')} height={104}>
                    <TableListCell width={104} type='Logo'>
                      <Link name='playerDetails' className="TableListCell-Avatar"  params={{id: user.get('id')}} style={{
                        backgroundImage: `url(${bgImage})`,
                        width: 104,
                        height: 104
                      }} />
                    </TableListCell>
                    <TableListCell width={696} type='Primary'>
                    <div className='TeamList-TeamInfo'>
                      <div className='TeamList-TeamTitleCountry'>
                        <div className='TeamList-TeamTitle Players-PlayerName'>
                          <Link name='playerDetails' params={{id: user.get('id')}}>
                            {user.get('nickname')}
                          </Link>
                        </div>
                        <div className='TeamList-TeamCountry'><Flag country={user.get('country')} outputName /></div>
                      </div>
                      { user.get('invite_sent') ?
                        <div className="Players-InviteWrapper">
                          <div className="TableListCell-InvitationSent">Приглашение отправлено</div>
                          <DataEditButton text='Отменить' backgroundType='light' onClick={invitePlayerCancel.bind(this, user)} />
                        </div> :
                        (!data.getIn(['user']) || user.get('id') !== data.getIn(['user', 'id'])) && !user.get('team') &&
                        <div className="Players-InviteWrapper">
                          <DataEditButton text='Пригласить' backgroundType='light' onClick={invitePlayer.bind(this, user)} />
                        </div>
                      }
                    </div>
                    </TableListCell>
                    <TableListCell width={112} type='Secondary' header='Матчей'>{user.get('total_games')}</TableListCell>
                    <TableListCell width={112} type='Secondary' header='Побед'>{user.get('won_games')}</TableListCell>
                    <TableListCell width={112} type='Secondary' header='Поражений'>{user.get('lost_games')}</TableListCell>
                    <TableListCell width={112} type='Secondary' header='Очки'>{user.get('score')}</TableListCell>
                  </TableListRow>
                })
              }
             {btnMore}
            </div>
            :
            <div className="Content-NoFound">
              Ничего не найдено
            </div>
        }
      </VBox>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/Players.js